document.addEventListener('DOMContentLoaded', () => {
  const shareButton = document.querySelector('.btn-share')
  const shareIcon = document.querySelector('.btn-icon-share')

  if (shareButton) {
    const handleShare = () => {
      const currentUrl = window.location.href
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

      const showSuccessIcon = () => {
        if (successTimeout) {
          clearTimeout(successTimeout)
        }
        shareIcon.classList.add('btn-icon-success')
        const successTimeout = setTimeout(() => shareIcon.classList.remove('btn-icon-success'), 1000)
      }

      if (isMobile && navigator.share) {
        navigator
          .share({
            text: 'Посмотри какая вакансия в Триаде',
            title: document.title,
            url: currentUrl,
          })
          .then(showSuccessIcon)
          .catch((err) => {
            console.error('Ошибка при использовании функции "Поделиться":', err)
          })
      } else {
        navigator.clipboard
          .writeText(currentUrl)
          // .then(showSuccessIcon) Если очень хочется можно кнопку сделать зеленой
          .then(alert('Ссылка на вакансию скопирована в буфер обмена!'))
          .catch((err) => {
            console.error('Ошибка при копировании ссылки:', err)
          })
      }
    }

    shareButton.addEventListener('click', handleShare)
  }
})
